import React from "react";
import PropTypes from "prop-types";
import DataDisplay from "../../dataDisplay/dataDisplay";

export const DataPoints = ({ dataPoints = [] }) => {
  if (!dataPoints.length) return null;
  return (
    <div className={"client-info-bottom"} style={{ justifyContent: "space-around" }}>
      {dataPoints.map(({ name, value }) => {
        return <DataDisplay key={name} label={name} value={value} disableAnimation={true} />;
      })}
    </div>
  );
};
